import { render, staticRenderFns } from "./addOzoneAlarmDialog.vue?vue&type=template&id=4b303ca1&scoped=true"
import script from "./addOzoneAlarmDialog.vue?vue&type=script&lang=js"
export * from "./addOzoneAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./addOzoneAlarmDialog.vue?vue&type=style&index=0&id=4b303ca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b303ca1",
  null
  
)

export default component.exports